<template>
  <div class="home-page">
    <h1>Dashboard Trello di Idearia</h1>
    Usa il menu in alto per navigare tra le varie funzioni a disposizione.
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
    name: 'home',
    components: {
        // HelloWorld,
    },
}
</script>
